import React from "react";
import { Form, Col, Alert, Button } from "react-bootstrap";


export default function NotEnrol() {

    return (
        <>   
      <Form.Row>
        <Col xs={12}>                        
        <Alert variant="light" className="align-items-center">
          <div className='d-flex justify-content-center'>
            <div md='6' className='mt-5'>
            <strong>IMPORTANT NOTE:</strong><br/><br/><br/>
            This scholarship is only applicable to Registered students.<br/><br/>
            Please complete the admission process at respective institutions below before submitting your scholarship application:<br/>
            Sunway University: <a href={"https://sunwayuniversity.edu.my/apply"}>https://sunwayuniversity.edu.my/apply</a><br/>
            Sunway College: <a href={"https://sunwaycollege.edu.my/admission"}>https://sunwaycollege.edu.my/admission</a><br/>
            <br/><br/>
            Thank you.
            </div>
          </div>
        <hr />
        </Alert>
        </Col>
        </Form.Row>
      </>
    );
}